import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Music } from "lucide-react";
import { Reveal } from "./Reveal";
import { Eucalyptus } from "./Botanical";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Rsvp = () => {
  const [song, setSong] = useState({ title: "", name: "" });
  const [songDone, setSongDone] = useState(false);
  const [songLoading, setSongLoading] = useState(false);

  const submitSong = async (e) => {
    e.preventDefault();
    if (song.title.trim().length < 2) {
      toast.error("نام آهنگ را بنویسید");
      return;
    }
    setSongLoading(true);
    try {
      await axios.post(`${API}/songs`, { title: song.title.trim(), name: song.name.trim() });
      setSongDone(true);
      toast.success("آهنگ شما ثبت شد");
    } catch {
      toast.error("خطایی رخ داد؛ دوباره تلاش کنید");
    } finally {
      setSongLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl border border-black/10 bg-white px-5 py-4 text-[#1A1612] placeholder-[#B9B1A7] focus:outline-none focus:border-[#C29B38] focus:ring-2 focus:ring-[#C29B38]/20 transition";

  return (
    <section
      id="rsvp"
      data-testid="wedding-rsvp-section"
      className="relative px-4 sm:px-8 lg:px-12 pt-12 sm:pt-16 pb-16 sm:pb-20 overflow-x-clip"
    >
      <Eucalyptus className="pointer-events-none absolute -top-4 -right-8 w-[clamp(calc(10rem*var(--bmin)),calc(0.18*var(--cw)),14rem)] opacity-70 -scale-x-100" />

      <div className="max-w-3xl mx-auto relative text-center">
        <Reveal>
          <p
            data-testid="rsvp-notice"
            className="text-base sm:text-lg font-light leading-loose text-[#6E6459]"
          >
            درصورتی که فرصت همراهی با ما را ندارید،
            <br />
            سپاسگزار می‌شویم تا پایان شهریور ماه ما را در جریان بگذارید
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            data-testid="song-request-form"
            className="mt-16 rounded-[2rem] bg-white border border-black/5 p-8 sm:p-10 shadow-[0_30px_60px_-40px_rgba(26,22,18,0.3)]"
          >
            <div className="flex items-center justify-center gap-3 mb-3">
              <Music size={19} className="text-[#C29B38]" />
              <h3 className="text-lg font-light text-[#524A42]">آهنگ پیشنهادی شما برای مراسم</h3>
            </div>
            <p className="text-sm text-[#8C827A] mb-6 font-light">
              آهنگ‌هایی را که دوست دارید حتماً پخش شود این‌جا بنویسید
            </p>
            {songDone ? (
              <div data-testid="song-success" className="py-4">
                <p className="text-[#1A1612] font-medium">ثبت شد؛ حتماً پخشش می‌کنیم!</p>
                <button
                  data-testid="song-another-button"
                  onClick={() => {
                    setSong({ title: "", name: "" });
                    setSongDone(false);
                  }}
                  className="mt-4 text-sm text-[#C29B38] underline underline-offset-4"
                >
                  ثبت آهنگ دیگر
                </button>
              </div>
            ) : (
              <form onSubmit={submitSong} className="flex flex-col sm:flex-row gap-3">
                <input
                  data-testid="song-title-input"
                  className={inputCls}
                  placeholder="نام آهنگ یا خواننده…"
                  value={song.title}
                  onChange={(e) => setSong({ ...song, title: e.target.value })}
                />
                <input
                  data-testid="song-name-input"
                  className={`${inputCls} sm:max-w-[180px]`}
                  placeholder="از طرف (اختیاری)"
                  value={song.name}
                  onChange={(e) => setSong({ ...song, name: e.target.value })}
                />
                <button
                  data-testid="song-submit-button"
                  type="submit"
                  disabled={songLoading}
                  className="rounded-full border border-[#1A1612]/20 bg-white text-[#1A1612] px-8 py-4 text-sm font-light whitespace-nowrap transition-all duration-300 hover:border-[#C29B38] hover:text-[#C29B38] active:scale-95 disabled:opacity-60"
                >
                  {songLoading ? "…" : "ثبت"}
                </button>
              </form>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
